import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { connect, createLocalVideoTrack } from 'twilio-video';
import './VideoCallModal.css';

const VideoCallModal = ({ open, onCancel, token }) => {
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const roomRef = useRef(null);
  const [isAudioMuted, setIsAudioMuted] = useState(false);
  const [isVideoMuted, setIsVideoMuted] = useState(false);

  useEffect(() => {
    const connectToRoom = async () => {
      if (token && open) {
        try {
          const room = await connect(token, {
            audio: true,
            video: { width: 640 },
          });

          roomRef.current = room;

          // Exibir o vídeo local (médico)
          const localTrack = await createLocalVideoTrack();
          localVideoRef.current.appendChild(localTrack.attach());

          // Exibir o vídeo remoto (paciente)
          room.on('participantConnected', (participant) => {
            participant.on('trackSubscribed', (track) => {
              remoteVideoRef.current.appendChild(track.attach());
            });
          });

          room.on('participantDisconnected', (participant) => {
            participant.tracks.forEach((publication) => {
              if (publication.isSubscribed) {
                const track = publication.track;
                track.detach().forEach((element) => element.remove());
              }
            });
          });
        } catch (error) {
          console.error('Erro ao conectar à sala do Twilio:', error);
        }
      }
    };

    if (open) {
      connectToRoom();
    }

    return () => {
      if (roomRef.current) {
        roomRef.current.disconnect();
        roomRef.current = null;
      }
    };
  }, [token, open]);

  const handleToggleAudio = () => {
    if (roomRef.current) {
      roomRef.current.localParticipant.audioTracks.forEach((publication) => {
        if (isAudioMuted) {
          publication.track.enable();
        } else {
          publication.track.disable();
        }
      });
      setIsAudioMuted(!isAudioMuted);
    }
  };

  const handleToggleVideo = () => {
    if (roomRef.current) {
      roomRef.current.localParticipant.videoTracks.forEach((publication) => {
        if (isVideoMuted) {
          publication.track.enable();
          localVideoRef.current.style.backgroundColor = 'transparent';
        } else {
          publication.track.disable();
          localVideoRef.current.style.backgroundColor = '#000'; // Mantém o fundo preto ao desabilitar o vídeo
        }
      });
      setIsVideoMuted(!isVideoMuted);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width="80%"
      className="video-call-modal"
    >
      <div className="video-call-content">
        <div className="video-section" ref={localVideoRef}>
          {/* Vídeo local (médico) */}
        </div>
        <div className="video-section" ref={remoteVideoRef}>
          {/* Vídeo remoto (paciente) */}
        </div>
      </div>
      <div className="control-buttons">
        <Button onClick={handleToggleAudio}>
          {isAudioMuted ? 'Ativar Áudio' : 'Desativar Áudio'}
        </Button>
        <Button onClick={handleToggleVideo}>
          {isVideoMuted ? 'Ativar Vídeo' : 'Desativar Vídeo'}
        </Button>
      </div>
    </Modal>
  );
};

VideoCallModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default VideoCallModal;
